module.exports = __webpack_public_path__ + "static/og-65141783fbfb6d158ee21efd0fc314a8.png";